import $ from 'jquery';
import { showSidebarTab } from '~src/sidebarLegacy';
import { getState, modifyState } from '~src/state';
import { hideCursor, showCursor } from '~core';
import Swal from 'sweetalert2';

let lastActiveObject;

export const selectErasingObject = () => {
  window.canvas.setActiveObject(lastActiveObject);
};

export const toggleObjectEraser = () => {
  const isErasing = getState('isErasing', false);

  if (isErasing) {
    window.canvas.isDrawingMode = false;
    hideCursor();
    selectErasingObject();
    modifyState('isErasing', false);
    if (lastActiveObject?._magicFrame?.type === 'MagicFrame') {
      lastActiveObject._magicFrame.toggleEraseMode();
    }
  } else {
    window.canvas.isDrawingMode = true;
    window.canvas.freeDrawingBrush.inverted = false;
    $('#editor-menu-undo-eraser')
      .text('Ripristina zona cancellata')
      .addClass('btn-secondary')
      .removeClass('btn-warning');
    showCursor();
    modifyState('isErasing', true);

    lastActiveObject = window.canvas.getActiveObject();
    if (!lastActiveObject) {
      Swal.fire({
        text: "Devi selezionare un'immagine per poter abilitare la gomma",
        icon: 'warning',
        confirmButtonColor: '#278e8e',
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    if (lastActiveObject._magicFrame?.type === 'MagicFrame') {
      lastActiveObject._magicFrame.toggleEraseMode();
    }

    lastActiveObject.set('erasable', true);
    showSidebarTab('object-eraser');
  }
};
